import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormTrash = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormTrash' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M7.5,9 L16.5,9 L16.5,19 L7.5,19 L7.5,9 Z M5,9 L19,9 M9.36363636,6 L14.3636364,6 L14.3636364,9 L9.36363636,9 L9.36363636,6 Z M10.5455,11 L10.5455,17 M13.5455,11 L13.5455,17' />
  </StyledIcon>
);
